import { WEB_ASSETS } from '@tenfour/contracts'

/**
 * Destination marks that are not in WEB_ASSETS yet, in the same
 * `{ idle, active } × { light, dark }` shape as `WEB_ASSETS.icons.pageHeaders`.
 *
 * `needsYou` is the design system's service bell for Needs your attention
 * (Corpus `artwork/icons/destinations/queue/{light,dark}/{active,idle}-v3.png`,
 * built to the page-header webp ladder; 128px siblings sit beside each file).
 * It lives here only because `packages/contracts/src/web-assets.ts` carries
 * unrelated in-flight work. TODO: move it into `WEB_ASSETS.icons.pageHeaders`
 * as `needsYou` (plus `PAGE_HEADER_ICON_KEYS` and the SHA-256 pins in
 * web-assets.test.ts) once that file is free, then delete this module.
 *
 * `settingsOverview` is the All settings page's mark: the same gear the rail's
 * All settings row and the user-row button wear (the chrome settings relief),
 * rather than the Business profile storefront its /settings prefix inherited.
 * The chrome set has no outline cut, so idle and active share the filled art.
 */
export const EXTRA_DESTINATION_ICONS = {
  needsYou: {
    idle: {
      light: '/icons/page-header/needs-you-idle-light-64.webp',
      dark: '/icons/page-header/needs-you-idle-dark-64.webp',
    },
    active: {
      light: '/icons/page-header/needs-you-light-64.webp',
      dark: '/icons/page-header/needs-you-dark-64.webp',
    },
  },
  settingsOverview: {
    idle: {
      light: WEB_ASSETS.icons.chrome.settings.light.oneX,
      dark: WEB_ASSETS.icons.chrome.settings.dark.oneX,
    },
    active: {
      light: WEB_ASSETS.icons.chrome.settings.light.oneX,
      dark: WEB_ASSETS.icons.chrome.settings.dark.oneX,
    },
  },
} as const

export type ExtraDestinationIconKey = keyof typeof EXTRA_DESTINATION_ICONS
